import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';
import { he, enUS } from 'date-fns/locale';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, locale: string = 'he'): string {
  return new Intl.NumberFormat(locale === 'he' ? 'he-IL' : 'en-IL', {
    style: 'currency',
    currency: 'ILS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatNumber(num: number, locale: string = 'he'): string {
  return new Intl.NumberFormat(locale === 'he' ? 'he-IL' : 'en-IL').format(num);
}

export function formatDate(date: Date | string, formatStr: string = 'dd/MM/yyyy', locale: string = 'he'): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, formatStr, { locale: locale === 'he' ? he : enUS });
}

export function formatDateTime(date: Date | string, locale: string = 'he'): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'dd/MM/yyyy HH:mm', { locale: locale === 'he' ? he : enUS });
}

export function getAgentColor(index: number): string {
  const colors = [
    'hsl(221, 83%, 53%)',  // Blue
    'hsl(142, 76%, 36%)',  // Green
    'hsl(38, 92%, 50%)',   // Orange
    'hsl(280, 65%, 60%)',  // Purple
    'hsl(0, 84%, 60%)',    // Red
    'hsl(180, 70%, 45%)',  // Teal
  ];
  return colors[index % colors.length];
}

export function getAgentBgColor(index: number): string {
  const colors = [
    'bg-blue-100 text-blue-800',
    'bg-green-100 text-green-800',
    'bg-orange-100 text-orange-800',
    'bg-purple-100 text-purple-800',
    'bg-red-100 text-red-800',
    'bg-teal-100 text-teal-800',
  ];
  return colors[index % colors.length];
}
